class Navigation extends HTMLElement {
    constructor() {
        super()
    }

    connectedCallback() {
        this.current_width = window.innerWidth, "loading" === document.readyState ? window.on("DOMContentLoaded", () => this.load()) : this.load()
    }

    load() {
        this.initGrid(), this.initNavigation(), this.initFilter(), this.openFilter(), this.toggleFilterMenuListener(), Shopify.designMode && this.sectionListeners()
    }

    initGrid() {
        this.body = document.querySelector("[data-body-root]"), this.grid_container = this.body.querySelector("[data-body-grid]"), this.max_columns = parseInt(this.body.getAttribute("data-max-columns")), this.num_columns = parseInt(this.grid_container.getAttribute("data-columns")), this.pagination = this.body.querySelector("[data-body-pagination]"), this.pagination_link = this.body.querySelector("[data-body-pagination-link]"), this.spinner = this.body.querySelector("[data-body-spinner]")
    }

    initNavigation() {
        this.active_price_tag = this.querySelector('.navigation--active-tag[data-type="price"]'), this.active_refine_tag = this.querySelector('.navigation--active-tag[data-type="refine"]'), this.active_sort_tag = this.querySelector('.navigation--active-tag[data-type="sort"]'), this.active_tags_container = this.querySelector(".navigation--tags-container"), this.active_tags_wrapper = this.querySelector(".navigation--active-tags"), this.clear_tags_button = this.querySelector(".navigation--active-clear"), this.layout_buttons = this.querySelectorAll(".navigation--layout-button"), this.refine_button = this.querySelector('.navigation--button[data-toggle-menu="refine-filter"]'), this.small_layout_button = this.layout_buttons[1], this.storage_name = this.getAttribute("data-storage-name"), this.url = this.getAttribute("data-url"), this.layout_buttons.length && 2 < this.max_columns ? (this.initLayout(), this.setLayout(), this.layoutListener()) : this.layout_buttons.forEach(t => t.style.display = "none")
    }

    initFilter() {
        var t, e;
        this.filter = this.parentNode.querySelector(".filter--root"), this.filter && (this.moveFilterOffCanvas(), this.browse_links = this.filter.querySelectorAll('[data-type="browse"] .filter--label'), this.current_sort_input = this.filter.querySelector('[data-type="sort"] .filter--input:checked'), this.filter_form = this.filter.querySelector(".filter--form"), this.menu_toggles = this.filter.querySelectorAll(".filter--toggle"), this.refine_links = this.filter.querySelectorAll('[data-type="refine"] .filter--label'), this.price_inputs = this.filter.querySelectorAll(".filter--price-input"), this.reset_button = this.filter.querySelector('.filter--button[data-type="reset"]'), this.sort_links = this.filter.querySelectorAll('[data-type="sort"] .filter--label'), this.swatch_inputs = this.filter.querySelectorAll('[data-is-swatches="true"] .filter--input'), this.menu_toggles.length && (this.menuToggleListeners(), this.clearAllListener()), this.browse_links.length && this.browseListener(), this.sort_links.length && (this.current_sort_input && (this.current_sort_link = this.current_sort_input.nextElementSibling, this.current_sort_value = this.current_sort_input.value, this.current_sort_label = this.current_sort_input.getAttribute("data-label")), this.sortListener(), this.renderActiveSort(), this.activeSortListener()), this.refine_links.length && (this.refineListener(), this.swatch_inputs.length && theme.swatches.setColors(this.swatch_inputs), this.renderActiveRefines()), this.price_inputs.length && (this.active_min = this.active_price_tag.querySelector("[data-min-price]"), this.active_max = this.active_price_tag.querySelector("[data-max-price]"), this.button_min_delta = 32, this.price_range_buttons = this.filter.querySelectorAll(".filter--price-range--button"), this.price_range_line = this.filter.querySelector(".filter--price-range--line"), this.price_range_transition = this.price_range_buttons[0].style.transition, t = parseInt(this.price_inputs[0].value), e = parseInt(this.price_inputs[1].value), this.prices = {
            current_min: t,
            pending_min: t,
            current_max: e,
            pending_max: e,
            max: parseFloat(this.price_inputs[1].getAttribute("max"))
        }, this.priceInputListeners(), this.renderActivePrice(), this.initPriceRangeListener(), this.activePriceListener()), this.toggleActiveTags())
    }

    openFilter() {
        "filter--open" === window.location.hash.substring(1) && this.refine_button && setTimeout(() => this.refine_button.trigger("click"), 200)
    }

    sectionListeners() {
        window.on("shopify:section:load", () => {
            theme.off_canvas.reset(), this.initGrid(), this.initNavigation(), this.initFilter(), window.trigger("theme:search:updateLinks")
        })
    }

    initLayout() {
        this.layout_buttons.forEach(t => t.removeAttribute("style")), this.small_layout_button.setAttribute("data-column-size", this.max_columns)
    }

    setLayout() {
        let e = parseInt(localStorage.getItem(theme.local_storage[this.storage_name]));
        e && (2 === e || e === this.num_columns) || (e = this.num_columns, localStorage.setItem(theme.local_storage[this.storage_name], e)), this.grid_container.setAttribute("data-columns", e), this.layout_buttons.forEach(t => {
            t.setAttribute("data-active", !1), parseInt(t.getAttribute("data-column-size")) === e && t.setAttribute("data-active", !0)
        }), window.trigger("theme:navigation:productsUpdated")
    }

    layoutListener() {
        this.layout_buttons.off("click keydown"), this.layout_buttons.on("click keydown", t => {
            "keydown" === t.type && "Enter" !== t.key || (t = parseInt(t.target.getAttribute("data-column-size")), localStorage.setItem(theme.local_storage[this.storage_name], t), this.setLayout())
        })
    }

    moveFilterOffCanvas() {
        const t = document.querySelector('[data-view="filter"]');
        t.innerHTML = "", t.appendChild(this.filter), window.trigger("theme:search:updateLinks")
    }

    menuToggleListeners() {
        this.menu_toggles.on("click keydown", t => {
            if ("keydown" !== t.type || "Enter" === t.key) {
                const e = t.target;
                t = "true" !== e.getAttribute("aria-expanded");
                e.setAttribute("aria-expanded", t);
                const i = e.nextElementSibling;
                t ? setTimeout(() => i.setAttribute("data-transition", "fade-in"), 0) : i.setAttribute("data-transition", "fade-out")
            }
        })
    }

    clearAllListener() {
        [this.clear_tags_button, this.reset_button].on("click keydown", t => {
            "keydown" === t.type && "Enter" !== t.key || (this.current_sort_link && this.current_sort_link.click(), this.price_inputs.length && this.clearPrices(), this.active_refine_tags.length && this.active_refine_tags.forEach(t => t.trigger("click")), t.target.focus())
        })
    }

    browseListener() {
        this.browse_links.on("click keydown", i => {
            if ("keydown" !== i.type || "Enter" === i.key) {
                const r = i.target.previousElementSibling;
                let t = !1, e;
                r.checked && (t = !0), setTimeout(() => {
                    e = t ? (r.checked = !1, theme.urls.all_products_collection) : r.value, location.href = "" + location.origin + e, setTimeout(() => theme.off_canvas.closeRight(), 350)
                }, 0)
            }
        })
    }

    sortListener() {
        this.sort_links.on("click keydown", e => {
            if ("keydown" !== e.type || "Enter" === e.key) {
                const i = e.target, r = i.previousElementSibling;
                let t = !1;
                r.checked && (t = !0), setTimeout(() => {
                    t ? (r.checked = !1, this.current_sort_link = !1, this.current_sort_label = !1, this.current_sort_value = !1) : (r.checked = !0, this.current_sort_link = i, this.current_sort_label = r.dataset.label, this.current_sort_value = r.value), this.showLoadingView(), this.renderActiveSort(), this.getAjaxUrl()
                }, 0)
            }
        })
    }

    priceInputListeners() {
        this.price_inputs.on("keydown", t => {
            var e = t.which;
            (e < 48 || 57 < e) && (e < 37 || 40 < e) && 8 !== e && 9 !== e && 13 !== e && 65 !== e && 67 !== e && 86 !== e && 88 !== e && 91 !== e && 188 !== e && 190 !== e && t.preventDefault()
        }), this.price_inputs.on("change", t => {
            const e = t.target;
            t = parseFloat(e.value);
            let i, r;
            e.dataset.hasOwnProperty("minPrice") ? t + this.price_min_delta > this.prices.current_max ? (t > this.prices.max - this.price_min_delta ? (i = this.prices.max - this.price_min_delta, this.prices.current_max = this.prices.max) : (i = t, this.prices.current_max = t + this.price_min_delta), e.value = i, this.prices.current_min = i, this.price_inputs[1].value = this.prices.current_max) : this.prices.current_min = t : e.dataset.hasOwnProperty("maxPrice") && (t > this.prices.max ? (e.value = this.prices.max, this.prices.current_max = this.prices.max) : this.prices.current_min + this.price_min_delta > t ? (t - this.price_min_delta < 0 ? (r = this.price_min_delta, this.prices.current_min = 0) : (r = t, this.prices.current_min = t - this.price_min_delta), e.value = r, this.prices.current_max = r, this.price_inputs[0].value = this.prices.current_min) : this.prices.current_max = t), this.getPriceRangePositions(), this.movePriceRangeButtons(), this.setPriceRangeFill(), this.renderActivePrice(), this.showLoadingView(), this.getAjaxUrl()
        })
    }

    initPriceRangeListener() {
        window.on("theme:offCanvas:rightOpened", () => {
            this.resetPriceRangeListeners(), this.loadPriceRange()
        })
    }

    resetPriceRangeListeners() {
        this.price_range_buttons.off("mousedown.priceRange touchstart.priceRange"), window.off("theme:offCanvas:rightOpened resize.priceRange"), window.off("mousemove.priceRange touchmove.priceRange mouseup.priceRange touchend.priceRange")
    }

    loadPriceRange() {
        this.getPriceRangeGeometry(), this.priceRangeResizeListener(), this.priceRangeListeners()
    }

    getPriceRangeGeometry() {
        this.restorePriceRangeTransitions(), this.price_range_width = this.price_range_line.offsetWidth, this.price_range_width && (this.pixels_per_price = this.price_range_width / this.prices.max, this.price_min_delta = Math.round(this.button_min_delta * (1 / this.pixels_per_price)), this.getPriceRangePositions(), this.movePriceRangeButtons(), this.setPriceRangeFill(), this.removePriceRangeTransitions())
    }

    getPriceRangePositions() {
        this.price_positions = {
            min: this.prices.current_min * this.pixels_per_price,
            max: this.prices.current_max * this.pixels_per_price
        }
    }

    movePriceRangeButtons() {
        this.price_range_buttons.forEach(t => {
            t.dataset.hasOwnProperty("maxPrice") ? t.style.transform = `translateX(-${this.price_range_width - this.price_positions.max}px)` : t.style.transform = `translateX(${this.price_positions.min}px)`
        })
    }

    setPriceRangeFill() {
        const t = this.price_range_line.firstElementChild;
        var e = this.price_range_width - this.price_positions.max;
        t.style.margin = `0 ${e}px 0 ${this.price_positions.min}px`, t.style.width = `calc(100% - ${e + this.price_positions.min}px)`
    }

    restorePriceRangeTransitions() {
        this.price_range_line.style.transition = this.price_range_transition, this.price_range_buttons.forEach(t => t.style.transition = this.price_range_transition)
    }

    removePriceRangeTransitions() {
        const t = [...this.price_range_buttons, this.price_range_line];
        0 === this.prices.current_min && this.prices.current_max === this.prices.max ? t.forEach(t => t.style.transition = "unset") : t.on("transitionend", () => {
            t.forEach(t => t.style.transition = "unset"), t.off("transitionend")
        })
    }

    priceRangeResizeListener() {
        window.on("resize.priceRange", theme.utils.debounce(100, () => {
            this.current_width !== window.innerWidth && (this.current_width = window.innerWidth, this.initPriceRangeListener(), this.getPriceRangeGeometry())
        }))
    }

    priceRangeListeners() {
        this.price_range_buttons.on("mousedown.priceRange touchstart.priceRange", t => {
            this.active_range_button = t.target, theme.utils.disable_swipe_listener = !0, "touchstart" === t.type ? this.drag_start = t.targetTouches[0].pageX : this.drag_start = t.pageX
        }), window.on("mousemove.priceRange touchmove.priceRange", t => {
            this.drag_start && (this.animation_request && cancelAnimationFrame(this.animation_request), this.animation_request = requestAnimationFrame(() => this.getNewButtonPosition(t)))
        }), window.on("mouseup.priceRange touchend.priceRange", () => {
            this.drag_start && (this.price_inputs.forEach(t => t.trigger("change")), this.drag_start = !1, theme.utils.disable_swipe_listener = !1, this.active_range_button.dataset.hasOwnProperty("maxPrice") ? this.prices.current_max = parseFloat(this.prices.pending_max) : this.prices.current_min = parseFloat(this.prices.pending_min))
        })
    }

    getNewButtonPosition(t) {
        let e;
        if (e = "touchmove" === t.type ? t.targetTouches[0].pageX - this.drag_start : t.pageX - this.drag_start, this.active_range_button.dataset.hasOwnProperty("maxPrice")) {
            let t = this.prices.current_max * this.pixels_per_price + e;
            t > this.price_range_width ? t = this.price_range_width : this.price_positions.min > t - this.button_min_delta && (t = this.price_positions.min + this.button_min_delta), this.price_positions.max = t, this.prices.pending_max = Math.round(t * (1 / this.pixels_per_price)), this.price_inputs[1].value = this.prices.pending_max
        } else {
            let t = this.prices.current_min * this.pixels_per_price + e;
            t < 0 ? t = 0 : t > this.price_positions.max - this.button_min_delta && (t = this.price_positions.max - this.button_min_delta), this.price_positions.min = t, this.prices.pending_min = Math.round(t * (1 / this.pixels_per_price)), this.price_inputs[0].value = this.prices.pending_min
        }
        this.movePriceRangeButtons(), this.setPriceRangeFill()
    }

    clearPrices() {
        let i = !1;
        this.price_inputs.forEach(t => {
            var e = parseFloat(t.value);
            t.dataset.hasOwnProperty("minPrice") && 0 !== e ? (t.value = 0, i = !0) : t.dataset.hasOwnProperty("maxPrice") && e !== this.prices.max && (t.value = this.prices.max, i = !0)
        }), i && this.price_inputs.forEach(t => t.trigger("change"))
    }

    refineListener() {
        this.refine_links.on("click keydown", t => {
            if ("keydown" !== t.type || "Enter" === t.key) {
                if ("Enter" === t.key) {
                    const e = t.target.previousElementSibling;
                    e.checked = !e.checked
                }
                setTimeout(() => {
                    const t = this.active_tags_wrapper.querySelectorAll('.navigation--active-tag[data-type="refine"]');
                    t.length && t.forEach(t => t.remove()), this.showLoadingView(), this.renderActiveRefines(), this.getAjaxUrl()
                }, 0)
            }
        })
    }

    getAjaxUrl() {
        var t = new FormData(this.filter_form);
        let e = new URLSearchParams(t);
        e.append("vendor",$('body').data("getcookie"));
        if($('body').data("getparty")!='' && $('body').data("getparty")!=null && $('body').data("getparty")!=undefined) {
            e.append("partycode", $('body').data("getparty"));
        }
        this.ajax_url = "" + this.url + e.toString(), history.replaceState({}, "", this.ajax_url), this.getGridHtml(), this.toggleActiveTags()
    }

    showLoadingView() {
        this.grid_container.innerHTML = "", this.grid_container.style.display = "none", this.pagination.style.display = "none", this.spinner.style.display = "flex"
    }

    async getGridHtml() {
        this.abort_controller && this.abort_controller.abort(), this.abort_controller = new AbortController;
        try {
            if (this.response = await fetch(this.ajax_url, {signal: this.abort_controller.signal}), !this.response.ok) throw new Error(response.statusText);
            {
                var t = await this.response.text();
                const e = theme.utils.parseHtml(t, "[data-body-root]");
                this.renderGridHtml(e), this.spinner.style.display = "none", this.grid_container.removeAttribute("style"), theme.quick_add.clearForms(), 0 < e.querySelectorAll(".product--root").length && this.formatProducts()
            }
        } catch {
        }
    }

    renderGridHtml(t) {
        var e = t.querySelector("[data-body-grid]").innerHTML,
            e = (this.grid_container.innerHTML = e, t.querySelector("[data-body-pagination]"));
        e ? (this.pagination.innerHTML = e.innerHTML, this.pagination.removeAttribute("style"), this.pagination_link && (this.pagination_link.style.display = "block")) : this.pagination_link && (this.pagination_link.style.display = "none")
    }

    formatProducts() {
        window.trigger("theme:navigation:productsUpdated"), theme.settings.quick_add && theme.off_canvas && theme.off_canvas.reset()
    }

    renderActiveSort() {
        this.current_sort_value ? (this.render_active_sort = !0, this.active_sort_tag.querySelector("span").textContent = this.current_sort_label, this.active_sort_tag.setAttribute("data-value", this.current_sort_value), this.active_sort_tag.removeAttribute("style")) : (this.render_active_sort = !1, this.active_sort_tag.style.display = "none")
    }

    renderActivePrice() {
        0 === this.prices.current_min && this.prices.current_max === this.prices.max ? (this.active_price_tag.style.display = "none", this.render_active_price = !1) : (this.render_active_price = !0, this.active_min.textContent = "" + this.prices.current_min, this.active_max.textContent = "" + this.prices.current_max, this.active_price_tag.removeAttribute("style"))
    }

    renderActiveRefines() {
        this.active_refine_tags = [], this.render_active_refine = !1;
        const i = {labels: [], names: [], swatches: [], values: []};
        if (this.filter.querySelectorAll('[data-type="refine"] input:checked').forEach(t => {
            i.labels.push(t.getAttribute("data-label")), i.names.push(t.name), i.values.push(t.value);
            const e = t.nextElementSibling;
            "swatch" === e.getAttribute("data-item") ? i.swatches.push(e.getAttribute("style")) : i.swatches.push(!1)
        }), 0 < i.values.length) {
            for (let e = 0; e < i.values.length; e++) {
                const t = this.active_refine_tag.cloneNode(!0),
                    r = (t.removeAttribute("style"), t.setAttribute("data-value", i.values[e]), t.setAttribute("data-name", i.names[e]), t.querySelector("span").textContent = i.labels[e], t.querySelectorAll('[data-item="swatch"]'));
                i.swatches[e] && r.length ? r.forEach(t => t.setAttribute("style", i.swatches[e])) : r.length && r.forEach(t => t.remove()), this.active_tags_wrapper.prepend(t), this.active_refine_tags.push(t)
            }
            this.render_active_refine = !0, this.activeRefineListeners()
        }
    }

    toggleActiveTags() {
        var t = this.render_active_refine || this.render_active_sort || this.render_active_price;
        this.active_tags_container.style.display = t ? "block" : "none"
    }

    activeSortListener() {
        this.active_sort_tag.on("click keydown", t => {
            "keydown" === t.type && "Enter" !== t.key || this.current_sort_link && this.current_sort_link.click()
        })
    }

    activePriceListener() {
        this.active_price_tag.on("click keydown", t => {
            "keydown" === t.type && "Enter" !== t.key || this.clearPrices()
        })
    }

    activeRefineListeners() {
        this.active_refine_tags.on("click keydown", t => {
            if ("keydown" !== t.type || "Enter" === t.key) {
                const s = t.target;
                this.refine_links.forEach(t => {
                    const e = t.previousElementSibling;
                    var i = s.getAttribute("data-value"), r = s.getAttribute("data-name");
                    e.value === i && e.name === r && (t.click(), e.checked = !1)
                })
            }
        })
    }

    toggleFilterMenuListener() {
        window.on("theme:navigation:toggleFilterMenu", t => {
            const i = t.detail;
            document.querySelectorAll(".filter--toggle").forEach(t => {
                t.setAttribute("aria-expanded", !1);
                const e = t.getAttribute("aria-controls");
                e.includes(i) && t.click()
            })
        })
    }
}

customElements.define("navigation-root", Navigation);